<div class="col-12 container-fluid">
  <div class="spinner-container mt-1" *ngIf="esperandoCarga">
    <ngx-spinner name="spinnerGrafico" [ngStyle]="{'height': '400px', 'z-index':'0'}" bdOpacity=0.3bd
                 Color="rgba(193,193,193,0)" size="medium" color="#185db5" type="ball-grid-beat" [fullScreen]="false">
      <p style="color: white">C a r g a n d o . . . </p>
    </ngx-spinner>
  </div>

  <ngb-alert class="alert alert-warning mt-2" *ngIf="padronesFiltrados.length == 0 && !esperandoCarga">
    No existen padrones en el historial
  </ngb-alert>
</div>
<div *ngIf="!esperandoCarga && padronesFiltrados.length>0" id="scroll-infinito" infinite-scroll
     [infiniteScrollDistance]="distance" [infiniteScrollThrottle]="throttle" [scrollWindow]="false"
     [infiniteScrollDisabled]="obteniendoDatosScroll || !padronesRecibidos || padronesRecibidos.length === 0"
     (scrolled)="onScrollPadrones()" class="mt-1">
  <div id="clientesPrint" *ngIf="padronesFiltrados.length > 0 && !esperandoCarga">
      <table class="table table-striped table-hover" id="tablaInformacion">
        <thead class="titulo text-center">
        <tr>
              <th>Nombre</th>
              <th>Descripci&oacute;n</th>
              <th>Fecha de carga</th>
              <th>Responsable</th>
        </tr>
        </thead>
        <tbody class="text-center ">
        <tr *ngFor="let padron of padronesFiltrados">
            <td>{{ padron.nombrePadron }}</td>
            <td>{{ padron.descripcion }}</td>
            <td>{{ padron.fechaDeCarga | date:"dd'/'MM'/'y' 'hh:mm a" }}</td>
            <td>{{ padron.responsable }}</td>
        </tr>
        </tbody>
      </table>
    <div style="justify-content: center;" *ngIf="obteniendoDatosScroll"
         class="d-flex align-items-center text-primary">
      <div class="spinner-border" role="status"></div><span>Cargando m&aacute;s datos..</span>
    </div>
  </div>
</div>
